import { Lock } from "lucide-react";

const Badge = ({ children, label }) => (
  <span className="flex h-6 items-center rounded border border-slate-300 bg-white px-1.5" aria-label={label} title={label}>{children}</span>
);

export const PayLogos = () => (
  <div className="flex flex-wrap items-center gap-1.5" data-testid="pay-logos">
    <Badge label="Visa"><span className="text-[11px] font-black italic tracking-tight text-[#1A1F71]">VISA</span></Badge>
    <Badge label="Mastercard"><svg viewBox="0 0 32 20" className="h-4 w-6"><circle cx="12" cy="10" r="8" fill="#EB001B" /><circle cx="20" cy="10" r="8" fill="#F79E1B" fillOpacity="0.9" /></svg></Badge>
    <Badge label="Apple Pay"><span className="text-[11px] font-bold text-black"><svg viewBox="0 0 24 24" className="-mt-0.5 mr-0.5 inline h-3 w-3" fill="currentColor"><path d="M16.4 12.6c0-2.4 2-3.5 2-3.6-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9s-1.8-.9-3-.8c-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.6 1.3-2.6s-2.5-1-2.5-3.7zM14.2 5.5c.6-.8 1.1-1.8 1-2.9-.9 0-2.1.6-2.7 1.4-.6.7-1.1 1.8-1 2.8 1 .1 2.1-.5 2.7-1.3z" /></svg>Pay</span></Badge>
    <Badge label="Google Pay"><span className="text-[11px] font-bold"><span className="text-[#4285F4]">G</span> <span className="text-slate-700">Pay</span></span></Badge>
  </div>
);

export const PayNote = () => (
  <div className="flex flex-wrap items-center justify-between gap-2 border-2 border-slate-200 bg-white px-3 py-2" data-testid="stb-pay-note">
    <span className="flex items-center gap-1.5 text-sm font-bold"><Lock className="h-4 w-4 text-lime-700" /> Secure payment – no cash needed</span>
    <PayLogos />
  </div>
);
